"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.route = route;

var _route = require("./route");

function route() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var nestedRoutes = arguments.length > 1 ? arguments[1] : undefined;
  var routeEntry;

  if (typeof path === 'string') {
    routeEntry = new _route.Route(path, nestedRoutes);
  } else {
    routeEntry = new _route.Route('', path);
  }

  var subRoutes = routeEntry._subRoutes;

  if (subRoutes) {
    var keys = Object.keys(subRoutes);
    var numSubRoutes = keys.length;

    for (var i = 0; i < numSubRoutes; i++) {
      var key = keys[i];
      var nestedEntry = subRoutes[key];
      nestedEntry._parent = routeEntry;
      routeEntry[key] = nestedEntry;
    }
  }

  return routeEntry;
}